import { getUserAuthorities } from "./authorities"

export const readUser = defineAbility((user) => {
  const authorities = getUserAuthorities(user)
  return authorities.includes("USER_READ")
})

export const editUser = defineAbility((user) => {
  const authorities = getUserAuthorities(user)
  return authorities.includes("USER_EDIT")
})

export const createUser = defineAbility((user) => {
  const authorities = getUserAuthorities(user)
  return authorities.includes("USER_CREATE")
})

export const deleteUser = defineAbility((user) => {
  const authorities = getUserAuthorities(user)
  return authorities.includes("USER_DELETE")
})
